const accountTypes = [
  "isp",
  "oem",
  "carrier",
  "msp",
  "si",
  "dcProvider",
  "reseller",
  "agent",
  "others",
  "sdWan",
];
const accTypeFullName = [
  "ISP",
  "OEM",
  "Carrier",
  "MSP",
  "SI",
  "DC Provider",
  "Reseller",
  "Agent",
  "Others",
  "SD-WAN",
];
const accTypeOptions = accountTypes.map((el, index) => ({
  label: accTypeFullName[index],
  value: el,
}));

export { accountTypes, accTypeFullName, accTypeOptions };
